import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-149f2bbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Basic infos", -1))
const _hoisted_2 = { class: "align" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " File name ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " File size ", -1))
const _hoisted_5 = { class: "align" }
const _hoisted_6 = { class: "wrap" }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "align" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Incremental ", -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Partial ", -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " A/B update ", -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " VAB ", -1))
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " VABC ", -1))
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Wipes Data ", -1))
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Total Dynamic Partition Size ", -1))
const _hoisted_31 = { key: 3 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Total VABC COW Size ", -1))
const _hoisted_33 = { key: 4 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " VABC Compression Algorithm ", -1))
const _hoisted_35 = { key: 5 }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Compression Factor ", -1))
const _hoisted_37 = { key: 6 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Cow Version ", -1))
const _hoisted_39 = { key: 7 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Security Patch Level ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.zipFile)
      ? (_openBlock(), _createElementBlock("div", _normalizeProps(_mergeProps({ key: 0 }, _ctx.$attrs)), [
          _createElementVNode("ul", _hoisted_2, [
            _createElementVNode("li", null, [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_ctx.zipFile.getFileName()), 1)
            ]),
            _createElementVNode("li", null, [
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.zipFile.getFileSize()) + " Bytes", 1)
            ])
          ])
        ], 16))
      : _createCommentVNode("", true),
    (_ctx.payload && _ctx.payload.metadata)
      ? (_openBlock(), _createElementBlock("div", _normalizeProps(_mergeProps({ key: 1 }, _ctx.$attrs)), [
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otaMetadata, (formatter) => {
              return (_openBlock(), _createElementBlock("li", {
                key: formatter.name
              }, [
                _createElementVNode("strong", null, _toDisplayString(formatter.name.trim() + ' '), 1),
                _createElementVNode("p", _hoisted_6, _toDisplayString(String(_ctx.payload[formatter.key]).trim()), 1)
              ]))
            }), 128))
          ])
        ], 16))
      : _createCommentVNode("", true),
    (_ctx.payload && _ctx.payload.manifest)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("ul", _hoisted_8, [
            _createElementVNode("li", null, [
              _hoisted_9,
              (_ctx.payload.preBuild)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, " ✅ "))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, " ❌ "))
            ]),
            _createElementVNode("li", null, [
              _hoisted_12,
              (_ctx.payload.manifest.partialUpdate)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, " ✅ "))
                : (_openBlock(), _createElementBlock("span", _hoisted_14, " ❌ "))
            ]),
            _createElementVNode("li", null, [
              _hoisted_15,
              (!_ctx.payload.manifest.nonAB)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, " ✅ "))
                : (_openBlock(), _createElementBlock("span", _hoisted_17, " ❌ "))
            ]),
            (_ctx.payload.manifest.dynamicPartitionMetadata)
              ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                  _hoisted_19,
                  (_ctx.payload.manifest.dynamicPartitionMetadata.snapshotEnabled)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, " ✅ "))
                    : (_openBlock(), _createElementBlock("span", _hoisted_21, " ❌ "))
                ]))
              : _createCommentVNode("", true),
            (_ctx.payload.manifest.dynamicPartitionMetadata)
              ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                  _hoisted_23,
                  (_ctx.payload.manifest.dynamicPartitionMetadata.vabcEnabled)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, " ✅ "))
                    : (_openBlock(), _createElementBlock("span", _hoisted_25, " ❌ "))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", null, [
              _hoisted_26,
              (_ctx.isDataWipePackage)
                ? (_openBlock(), _createElementBlock("span", _hoisted_27, " ✅ "))
                : (_openBlock(), _createElementBlock("span", _hoisted_28, " ❌ "))
            ]),
            (_ctx.totalDynamicPartitionSize)
              ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                  _hoisted_30,
                  _createTextVNode(" " + _toDisplayString(_ctx.totalDynamicPartitionSize), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.totalCOWSize)
              ? (_openBlock(), _createElementBlock("li", _hoisted_31, [
                  _hoisted_32,
                  _createTextVNode(" " + _toDisplayString(_ctx.totalCOWSize), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.vabcCompressionParam)
              ? (_openBlock(), _createElementBlock("li", _hoisted_33, [
                  _hoisted_34,
                  _createTextVNode(" " + _toDisplayString(_ctx.vabcCompressionParam), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.compressionFactor)
              ? (_openBlock(), _createElementBlock("li", _hoisted_35, [
                  _hoisted_36,
                  _createTextVNode(" " + _toDisplayString(_ctx.compressionFactor), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.cowVersion)
              ? (_openBlock(), _createElementBlock("li", _hoisted_37, [
                  _hoisted_38,
                  _createTextVNode(" " + _toDisplayString(_ctx.cowVersion), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.securityPatchLevel)
              ? (_openBlock(), _createElementBlock("li", _hoisted_39, [
                  _hoisted_40,
                  _createTextVNode(" " + _toDisplayString(_ctx.securityPatchLevel), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}